module.exports = __webpack_public_path__ + "img/mcgl_fp_02.2d977535.png";